module.exports = __webpack_public_path__ + "static/img/icon-pulsar.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/icon-pulsar.png
// module id = zoBY
// module chunks = 0